module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h14"
  }, [_vm._v("Prologue")]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "t2"
  }, [_c('img', {
    attrs: {
      "alt": "img4.png",
      "src": "Images/img4.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "t8"
  }, [_vm._v("FINN DE MORISCO")])]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t10"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p8"
  }, [_c('span', {
    staticClass: "t11"
  }, [_vm._v("“N")]), _c('span', {
    staticClass: "t12"
  }, [_vm._v("OT")]), _vm._v(" "), _c('span', {
    staticClass: "t10"
  }, [_vm._v("enough?” My voice cut through the heavy silence that filled the cab of the truck. It was abrasive, the sound making the moment seem more real. I lowered it to a whisper as I turned to look out past the driveway, searching the dark street beyond.")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "t10"
  }, [_vm._v("“Our love wasn’t enough?” He wasn’t anywhere. The solitude of the neighborhood suddenly made the street I’d grown up on sinister and oppressive. I couldn’t find any trace of him. I whipped around, hitting my left elbow on the steering wheel, and looked out the driver’s side window, expecting to see Brett standing there. Waiting to tell me he’d changed his mind. That he couldn’t walk away after all.")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "t10"
  }, [_vm._v("Nothing. Only the sidewalk that led to Mom and Dad’s front door, illuminated by the porch light only a few yards away. “I wasn’t enough.”")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "t13"
  }, [_vm._v("Of course you weren’t enough. Haven’t I been telling you that for days? You’re a sorry excuse for a man, let alone a warlock. Can’t even hold on to your demon of a boyfriend.")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "t10"
  }, [_vm._v("I ignored the berating voice that filled my mind. I wasn’t going to let it intrude into this moment. Even if what it said was true.")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "t10"
  }, [_vm._v("Turning back, I stared at the steering wheel. Why had I fixed it? I should have left Brett’s melted handprints, a testament to him. A memorial. I wrapped my fingers around where his imprint had been.")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "t10"
  }, [_vm._v("It didn’t matter. He’d be back. He had to be. He’d just been freaked out by whatever it was the nymphs had said to him on the cliff. He had every right to be. It hadn’t even been two weeks since he’d been attacked, since his best friend had been killed. He just needed some time.")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "t10"
  }, [_vm._v("He loved me. He’d be back.")])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "t13"
  }, [_vm._v("No he won’t.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t10"
  }, [_vm._v("A motion caught my attention. The front door of the house opened, spilling light in an arc over the yard.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t10"
  }, [_vm._v("Before I could see who it was, I jammed the truck into reverse and slammed my foot on the gas. Once out of the driveway, I paused just long enough to tap the break and switch to drive. Just long enough to hear Mom’s worried voice carry through the night. Just long enough for my tears to start to fall again.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t10"
  }, [_vm._v("I was over two blocks away from the house before I had the sense to begin to look for Brett again. Still, there was nothing in the pools of yellow light that fell from the street lamps. There weren’t even other people wandering around the neighborhood. There was only me.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t10"
  }, [_vm._v("How long had I lain there curled up in a pathetic ball in the seat of my truck, alternating between sobbing and utter disbelief? Ten minutes? Twenty? How far away could Brett have gotten in that amount of time?")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t10"
  }, [_vm._v("I just needed to find him. To reassure him that he was going to be okay. That we were going to be okay. That as long as we loved each other, everything was going to work out.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t13"
  }, [_vm._v("And how many times did you have to do that in the two minutes you and the demon played house? He didn’t love you. He felt sorry for you. He tried to leave you nearly every second you were together. He just kept wussing out because he didn’t want to make you cry. He finally grew a pair, didn’t he? That’s more than I can say for you.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t10"
  }, [_vm._v("“Shut up!” My arms jerked as I screamed, pulling the truck to the right and popping the front tire over the curb and onto the sidewalk. I overcorrected, driving into the oncoming lane before getting control once more, tears streaming harder as I continued to rage at the voice. “He did love me! Brett loved me. He loves me. You’ll see. He’ll be back any moment. He’ll be back at Mom and Dad’s before I return. Maybe he’s already back at my house, just waiting.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t10"
  }, [_vm._v("The voice didn’t reply, just issued a long, satisfied laugh.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t10"
  }, [_vm._v("“He loves me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t10"
  }, [_vm._v("I drove a few more feet, until I was exactly halfway between two light posts, allowing most of the truck to be cloaked in shadow. I’d already wasted too much time. I should have followed him as soon as he walked away. I’d only confirmed what he’d said, that love wasn’t enough. At the first chance, I’d let him down. He just needed to know I wasn’t going to give up.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t10"
  }, [_vm._v("The nagging feeling kept returning. At first I’d thought it was the voice when I’d felt it as Brett shut the door of the truck.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t10"
  }, [_vm._v("This time was different.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t10"
  }, [_vm._v("I’d heard it in his voice. Seen it in his eyes. This wasn’t like his other moments of panic.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t10"
  }, [_vm._v("That sensation was harder to block than the voice. I wished the sensations were from whoever taunted my mind. It would have made them less true.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t10"
  }, [_vm._v("I pushed them away again.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t10"
  }, [_vm._v("A locator spell. Of course. All I needed to do was focus on him. I’d found him easily enough in the graveyard the other time he’d left.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t10"
  }, [_vm._v("I removed my hands from the steering wheel and placed them in my lap. My fingers ached from the strangling grip they’d held. I closed my eyes, trying to block out everything else.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t10"
  }, [_vm._v("As soon as Brett’s face rose in my mind, a searing pain cut through my chest. A mixture of emotional and physical agony so intense it took my breath away.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t13"
  }, [_vm._v("Yes, so powerful. What a mighty warlock you are. Can’t even do a locator spell.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t10"
  }, [_vm._v("Again, I shoved the voice from me, doubling my efforts to bring Brett into focus. See his beautiful face, feel his turmoil.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t10"
  }, [_vm._v("Starbursts of white light exploded behind my eyes, my brain experiencing a sort of massive brain freeze.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t10"
  }, [_vm._v("I sat there, managing nothing more than dragging in deep, shuddering breaths. Even that felt like too monumental a task.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t10"
  }, [_vm._v("Finally, the pain ebbed, and my pulse began to slow.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t10"
  }, [_vm._v("“You’re doing this, aren’t you? You’re making it where I can’t find Brett.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t13"
  }, [_vm._v("If you’re such a great warlock, I wouldn’t be able to do such a thing, would I?")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t10"
  }, [_vm._v("“Why are you doing this? Let me find him.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t13"
  }, [_vm._v("He doesn’t want to be found.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t10"
  }, [_vm._v("Another rush of those feelings returned, not brought on by the voice, though confirming its claim. Brett didn’t want to be found. He didn’t want me.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t10"
  }, [_vm._v("I should go home. To my home, not Mom and Dad’s. Brett wasn’t there. The vampire wouldn’t be coming. Maybe Brett would show up if I were at home. I shook myself. He wasn’t going to be at my house. Not tonight. He’d be back. He had to be. We were meant to be. I just needed to have faith. Let him take his space. I didn’t need to suffocate him. That wouldn’t help.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t13"
  }, [_vm._v("You could make yourself forget him. Or cause him to feel all the pain you feel. I bet even a useless lump like you could pull that off. I’d help.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t10"
  }, [_vm._v("The suggestion was so out of the realm of possibilities I couldn’t even respond for several seconds. “I’d never hurt him. Ever. And I don’t want to forget him. I could never do that. Plus, he’ll be back.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t10"
  }, [_vm._v("I looked up at the stars, dim through the dusty windshield. He was out there. He was struggling and hurting. He was afraid. But he loved me. Loves me. Brett loves me.")])]), _vm._v(" "), _c('p', {
    staticClass: "p10"
  }, [_c('span', {
    staticClass: "t10"
  }, [_vm._v("He’d be back.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47c385e5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/005.vue
// module id = 66
// module chunks = 0